import React, {useState}          from "react";
import { useDispatch }            from "react-redux";
import classnames                 from 'classnames';

import { FontAwesomeIcon }        from '@fortawesome/react-fontawesome';
import { faSearch }               from '@fortawesome/free-solid-svg-icons';
import { faSpinner }              from '@fortawesome/free-solid-svg-icons';
import { Modal }                  from 'react-bootstrap';
import Messages                   from "pu-react/components/Messages";
import Substitute                 from "./Substitute";

import { 
  getSubstitutes, 
} from "../../bomSlice";

import { 
  searchPossibleSubstitutes 
} from "product_tabs/tab_parts/slice/search_parts";

const SearchModal = (props) => {
  const dispatch = useDispatch();
  const [exact_qty, setExactQty] = useState(0);
  const [keyword, setKeyword] = useState("")

  const {
    bom_line_item,
    loading,
    markups,
    messages,
    selected_board_qty,
    substitutes,
    show,
    onHide,
    onReplacePart,
  } = props;

  const placeholder = "Enter a manufacturer or vendor part number."
  const identifier = bom_line_item ? (bom_line_item.mpn || bom_line_item.distributor_part_number) : ""
  const selected_markup = markups && markups[selected_board_qty] ? markups[selected_board_qty] : 0

  const onShow = () => {
    if(!bom_line_item){
      onHide()
      return
    }

    setExactQty(bom_line_item.qty * selected_board_qty)
    dispatch(getSubstitutes(bom_line_item.id))
  }

  const onSearch = () => {
    dispatch(searchPossibleSubstitutes(bom_line_item.id, keyword))
  }

  return (
    <Modal 
      className="search-substitute-modal" 
      show={show} 
      onHide={onHide}
      size="xl"
      onShow={onShow} 
      centered>
      <Modal.Header closeButton>
        <Modal.Title>Search Substitutes for {identifier}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Messages messages={messages} />
        <div className="row">
          <div className="col-5">
            <div className="input-group mb-3">
              <input type="text" className="form-control" placeholder={placeholder} aria-label={placeholder} aria-describedby="button-addon2" 
                value={keyword} onChange={(e) => setKeyword(e.target.value)} disabled={loading}/>
              {!loading ? (
                <button className="btn btn-primary" type="button" id="button-addon2" onClick={onSearch}>
                  <i><FontAwesomeIcon icon={faSearch}/></i>
                </button>
              ) : (
                <button className="btn btn-primary" type="button" id="button-addon2" disabled>
                  <i><FontAwesomeIcon icon={faSpinner} spin/></i>
                </button>
              )}
              
            </div>
          </div>
        </div>
        <div id="search-table"className={classnames("table-responsive mt-2", {
            "custom-height": substitutes.length > 7,
          })}>
          <h4 className="fw-normal">Possible Substitutes</h4>
          <table className="table table-hover">
            <thead className="table-light">
              <tr>
                <th>Manufacturer Part Number</th>
                <th>Description</th>
                <th>Unit Price</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {loading && 
                <tr>
                  <td colSpan="4" className="text-center">
                    Searching substitutes
                  </td>
                </tr>
              }
              {!loading && (!substitutes || (substitutes && substitutes.length == 0)) && 
                <tr>
                  <td colSpan="4" className="text-center">
                    No substitutes found
                  </td>
                </tr>
              }
              {!loading && substitutes && substitutes.length > 0 && substitutes.map((substitute, index) => (
                <Substitute 
                  key={`substitute-${index}`} 
                  exact_qty={exact_qty}
                  markup={selected_markup}
                  selected_board_qty={selected_board_qty}
                  substitute={substitute}
                  onReplacePart={onReplacePart}/>
              ))}
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="row">
          <div className='col-5'></div>
          <div className='col-6 d-flex justify-content-end'>
            { loading && 
              <button type="button" 
                className="btn btn-outline-primary" 
                disabled>
                Loading...
              </button>
            }
            { !loading &&
              <>
                <button type="button" 
                  className="btn btn-outline-primary" 
                  onClick={onHide}>
                  CANCEL
                </button>
              </>
            }
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default SearchModal;